import { render, staticRenderFns } from "./BasCustomerModal.vue?vue&type=template&id=f2f0ded2&scoped=true&"
import script from "./BasCustomerModal.vue?vue&type=script&lang=js&"
export * from "./BasCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./BasCustomerModal.vue?vue&type=style&index=0&id=f2f0ded2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f0ded2",
  null
  
)

export default component.exports